import React, { useState, } from 'react';
import fileDownload from 'js-file-download';
import { TextEncoder, } from 'text-encoding';
import { unparse as unparseCsv, } from 'papaparse';
import { union, chunk, isFunction } from 'lodash';
import classnames from 'classnames';
import { Button, } from 'reactstrap';
import { toast } from 'react-toastify';

const { keys } = Object;

export default function ExportButton ({ label = 'エクスポート', fileName, rows, streamRows, children, ...extraProps }) {
  const [isExporting, setIsExporting] = useState(false);

  // NOTE: 通常モード — rows を一括でメモリに展開して CSV 化する
  const exportRows = async (encoder) => {
    const _rows = isFunction(rows) ? (await rows()) : rows;
    const fields = union(...chunk(_rows, 1000).map(_ => union(..._.map(keys))));
    return [encoder.encode(unparseCsv({ fields, data: _rows.map(r => fields.map(_ => r[_])) }))];
  };

  // NOTE: ストリーミングモード — チャンクごとに CSV 断片を生成・エンコードし、
  //       全件をメモリに保持しない（大量件数でブラウザが落ちるのを防ぐ）
  const exportStreamRows = async (encoder) => {
    let fields = null;
    const chunks = [];
    await streamRows(async (rowsChunk) => {
      if(rowsChunk.length === 0) return;
      // NOTE: 最初のチャンクでヘッダを確定。以降は同じ fields で揃える
      const isFirstChunk = fields == null;
      if(isFirstChunk) fields = union(...rowsChunk.map(keys));
      // NOTE: fields に無いキーが後続チャンクで出たら欠落するので検知してログに残す
      const unknownFields = union(...rowsChunk.map(keys)).filter(_ => !fields.includes(_));
      if(unknownFields.length > 0) console.warn('ExportButton: ヘッダに無いフィールドを検出', unknownFields);
      const csv = unparseCsv({ fields, data: rowsChunk.map(r => fields.map(_ => r[_])) }, { header: isFirstChunk });
      chunks.push(encoder.encode(isFirstChunk ? csv : '\r\n' + csv));
    });
    return chunks;
  };

  const onClickExport = async () => {
    setIsExporting(true);
    try {
      const encoder = new TextEncoder('Shift_JIS', { NONSTANDARD_allowLegacyEncoding: true });
      const parts = streamRows != null ? (await exportStreamRows(encoder)) : (await exportRows(encoder));
      const totalLength = parts.reduce((x, _) => x + _.length, 0);
      const fileContent = parts.reduce((x, part) => {
        x.array.set(part, x.offset);
        return { array: x.array, offset: x.offset + part.length };
      }, { array: new Uint8Array(totalLength), offset: 0 }).array;
      fileDownload(fileContent, fileName);
    } catch(e) {
      console.error(e);
      toast.error(`エクスポートに失敗しました。${e.message}`);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button color="secondary" onClick={onClickExport} disabled={isExporting} {...extraProps}>
      <span className={classnames('fas mr-1', { 'fa-spin fa-spinner': isExporting, 'fa-download': !isExporting })} />
      {children || label}
    </Button>
  );
};
